export enum AppRoles {
  Manager = 'manager',
  FrontDesk = 'front desk',
  Admin = 'admin',
}
